import { render, staticRenderFns } from "./KmAutomaticoList.vue?vue&type=template&id=13d6ca10&scoped=true"
import script from "./KmAutomaticoList.vue?vue&type=script&lang=js"
export * from "./KmAutomaticoList.vue?vue&type=script&lang=js"
import style0 from "./KmAutomaticoList.vue?vue&type=style&index=0&id=13d6ca10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d6ca10",
  null
  
)

export default component.exports